import { LocaleKeys } from '../../../../locale/translation-types'

export enum InterestEnum {
  CITY = 'CITY',
  COUNTRYSIDE = 'COUNTRYSIDE',
  ANIMALS = 'ANIMALS'
}

export const interestEnumMapping: Record<InterestEnum, LocaleKeys> = {
  [InterestEnum.CITY]: 'interest.enum.CITY',
  [InterestEnum.COUNTRYSIDE]: 'interest.enum.COUNTRYSIDE',
  [InterestEnum.ANIMALS]: 'interest.enum.ANIMALS'
}
